import { Search, Lightbulb, Map, Users, BarChart3, Target, TrendingUp, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { DELIVERABLES } from "@/data/portfolio";
import { track } from "@/lib/analytics";
import { T, useLang } from "@/lib/i18n";


const ICONS = { Search, Lightbulb, Map, Users, BarChart3, Target, TrendingUp };

export default function Deliverables() {
  const { t } = useLang();
  return (
    <section
      id="deliverables"
      data-testid="deliverables-section"
      className="border-t border-[#e5e0d8] section-pad bg-[#f2ece4]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-16">
        <div className="max-w-2xl">
          <div className="font-mono-label text-[11px] text-[#9a7218]">{t("05 · My deliverables")}</div>
        </div>

        <div className="mt-8 grid lg:grid-cols-2 gap-5">
          {DELIVERABLES.map((col, ci) => (
            <div
              key={col.group}
              data-testid={`deliverables-col-${ci}`}
              className="bg-white border border-[#e5e0d8] rounded-lg overflow-hidden"
            >
              <h3 className="px-6 py-4 bg-[#faf8f5] border-b border-[#e5e0d8] font-display text-lg text-[#14352a]">
                {t(col.group)}
              </h3>
              <ul>
                {col.items.map((it, i) => {
                  const Icon = ICONS[it.icon];
                  return (
                    <li
                      key={it.title}
                      data-testid={`deliverable-${ci}-${i}`}
                      className="flex items-start gap-4 px-6 py-5 border-b border-[#e5e0d8] last:border-0"
                    >
                      <span className="shrink-0 w-10 h-10 grid place-items-center rounded-md bg-[#f6efdc] text-[#9a7218]">
                        <Icon className="h-4 w-4" />
                      </span>
                      <div className="min-w-0">
                        <div className="text-base font-medium text-[#14352a] leading-snug">{t(it.title)}</div>
                        <p className="mt-1 text-sm text-[#55625b] leading-relaxed">{t(it.body)}</p>
                        <Link
                          to={it.to}
                          data-testid={`deliverable-proof-${ci}-${i}`}
                          onClick={() => track("deliverable_proof", { title: it.title })}
                          className="mt-2 inline-flex items-center gap-1 font-mono-label text-[9px] text-[#9a7218] link-underline"
                        >
                          {t("Seen in")}: {t(it.proof)} <ArrowUpRight className="h-3 w-3" />
                        </Link>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
